import React, { createContext, Dispatch, useState, SetStateAction } from 'react';

import { Usuario, AppContextType } from "../types";

export const AppContext = createContext({} as AppContextType);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AppProvider({ children }: any) {
    const [usuario, setUsuario] = useState<Usuario>({} as Usuario);
    return (
        <AppContext.Provider value={{
            usuario,
            setUsuario
        }}>
            {children}
        </AppContext.Provider>
    );
}